/**
 * 
 * key
 * 
 */


const key = 'cHJvZHVjdF92ZXJzaW9u'

export default key 